import { TAssetBatch } from "shared/types/assetExporter";

export const getAllAssetBatchIds = (assetBatches: TAssetBatch[]) =>
  assetBatches
    ?.filter(assetBatch => !!assetBatch.assetBatchId)
    .map(assetBatch => assetBatch.assetBatchId ?? "");
